module.exports = __webpack_public_path__ + "static/src/content/images/processed/200/Ramy-Youssef.11a2806.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/200/Ramy-Youssef.jpg
// module id = RvMy
// module chunks = 0